var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{attrs:{"id":"crossHair"}},[_c('line',_vm._b({},'line',{
            id : 'crossHair-horizLine',
            x1 : _vm.mousePos.x - _vm.size,
            y1 : _vm.mousePos.y,
            x2 : _vm.mousePos.x + _vm.size,   
            y2 : _vm.mousePos.y,
        },false)),_c('line',_vm._b({},'line',{
            id : 'crossHair-vertLine',
            x1 : _vm.mousePos.x,
            y1 : _vm.mousePos.y - _vm.size,
            x2 : _vm.mousePos.x,   
            y2 : _vm.mousePos.y + _vm.size,
        },false))])
}
var staticRenderFns = []

export { render, staticRenderFns }